import React from "react";
import { useTranslation } from "react-i18next";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import QuteContainer from "../containers/global/global-qute/index.jsx";
import PortfolioContainer from "../containers/global/portfolio/index.jsx";
import AboutService from "../containers/about/about-service/index.jsx";
import AboutGallery from "../containers/about/gallery";
import IntroContainer from "../containers/home/intro/index.jsx";
import PageTitleContainer from "../containers/global/page-title-without-photo";
import HomeData from "../data/home.json";
import Footer from "../layouts/footer";
import Header from "../layouts/header/index";
import Layout from "../layouts/index";

const HomePage = () => {
    const { t, i18n } = useTranslation();
    const currenLanguage = i18n.language;
    const data = HomeData[1]["qute"][currenLanguage];
    return (
        <React.Fragment>
            <Layout>
                <SEO title={t("title")} description={t("description")} />
                <div className="wrapper home-default-wrapper">
                    <Header classOption="hb-border" />
                    <div className="main-content">
                        <IntroContainer />
                        <AboutService />
                        <AboutGallery />
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default HomePage;
